import Loadable from 'react-loadable';
import Loading from '../components/loader/ZLoader';
//Login 
export const Login = Loadable({
  loader: () => import('../containers/login/Login'),
  loading: Loading,
})

//MyCalender
export const MyCalender = Loadable({
  loader: () => import('../containers/mycalender/MyCalender'),
  loading: Loading,
})

//Capacity Plan
export const capacityuserplan = Loadable({
  loader: () => import('../containers/CapacityPlaning/capacityuserplan'),
  loading: Loading,
})

export const Header = Loadable({
  loader: () => import('../navigation/Header'),
  loading: Loading,
})

export const Dashboard = Loadable({
  loader: () => import('../containers/dashboard/Dashboard'),
  loading: Loading,
})
export const Loginuserid = Loadable({
  loader: () => import('../containers/login/Loginuserid'),
  loading: Loading,
})
export const NotFound = Loadable({
  loader: () => import('../components/page_notfound/ZNotFoundDedicated'),
  loading: Loading,
})
export const ZNotfound = Loadable({
  loader: () => import('../components/errorBoundary/ZNotfound'),
  loading: Loading,
})

export const Reports = Loadable({
  loader: () => import('../containers/reports/Reports'),
  loading: Loading,
})

// export const UserList = Loadable({
//   loader: () => import('../containers/User/userslist'),
//   loading: Loading,
// })
export const MyTeam = Loadable({
  loader: () => import('../containers/myteam/MyTeam'),
  loading: Loading,
})

export const DeepDive = Loadable({
  loader: () => import('../containers/myteam/DeepDive'),
  loading: Loading,
})

export const AbsenceReport = Loadable({
  loader: () => import('../containers/myteam/AbsenceReport'),
  loading: Loading,
})

export const ExecuteSummary = Loadable({
  loader: () => import('../containers/myteam/ExecuteSummary'),
  loading: Loading,
})

export const AppConfig = Loadable({
  loader: () => import('./applicationCategory/AppConfig'),
  loading: Loading,
})

export const ApplicationCategory = Loadable({
  loader: () => import('./applicationCategory/ApplicationCategory'),
  loading: Loading,
})

export const ManageException = Loadable({
  loader: () => import('./applicationCategory/ManageException'),
  loading: Loading,
})

export const TrakzoLive = Loadable({
  loader: () => import('./trakzolive/TrakzoLive'),
  loading: Loading,
})

export const ApplicationList = Loadable({
  loader: () => import('./applicationCategory/ApplicationList'),
  loading: Loading,
})

export const EditUser = Loadable({
  loader: () => import('../containers/User/userdetail'),
  loading: Loading,
})
export const Organization = Loadable({
  loader: () => import('../containers/Organization/Organization'),
  loading: Loading,
})

export const AgentConfiguration = Loadable({
  loader: () => import('../containers/agentConfiguration/AgentConfiguration'),
  loading: Loading,
})
export const BillinPlan = Loadable({
  loader: () => import('./billingandsubcription/BillingAndPlan'),
  loading: Loading,
})

export const ScreenShotConfig = Loadable({
  loader: () => import('../containers/screenShotConfig/ScreenShotConfig'),
  loading: Loading,
})

export const SystemResource = Loadable({
  loader: () => import('../containers/myteam/SystemResource'),
  loading: Loading,
})

export const UploadLicense = Loadable({
  loader: () => import('../containers/license/UploadLicense'),
  loading: Loading,
})

export const Licence = Loadable({
  loader: () => import('../containers/license/Licence'),
  loading: Loading,
})

export const OfflineTime = Loadable({
  loader: () => import('../containers/offlineTimeRequest/OfflineTimes'),
  loading: Loading,
})

export const OfflineTimeRequest = Loadable({
  loader: () => import('../containers/offlineTimeRequest/OfflineTime'),
  loading: Loading,
})

export const OfflineTimeLog = Loadable({
  loader: () => import('../containers/offlineTimeRequest/OfflineTimeLog'),
  loading: Loading,
})

export const TimeSheet = Loadable({
  loader: () => import('../containers/timeSheet/TimeSheet'),
  loading: Loading,
})

export const myDashboard = Loadable({
  loader: () => import('./dashboard/TimeSheetDashboard'),
  loading: Loading,
})


export const Leave = Loadable({
  loader: () => import('./leave/Leave'),
  loading: Loading,
})

export const Worktimeconfiguration = Loadable({
  loader: () => import('./Worktimeconfiguration/Worktimeconfiguration'),
  loading: Loading,
})

export const WorkTime = Loadable({
  loader: () => import('./Worktimeconfiguration/WorkTime'),
  loading: Loading,
})

export const DashboardDelegation = Loadable({
  loader: () => import('./DashboardDelegation/DashboardDelegation'),
  loading: Loading,
})

export const MailSchedular = Loadable({
  loader: () => import('./mailSchedular/MailSchedular'),
  loading: Loading,
})

export const GenericHoliday = Loadable({
  loader: () => import('./genericHoliday/GenericHoliday'),
  loading: Loading,
})

export const MyAccount = Loadable({
  loader: () => import('./myAccount/MyAccount'),
  loading: Loading,
})

export const OverTimeRules = Loadable({
  loader: () => import('./Worktimeconfiguration/OverTimeRules'),
  loading: Loading,
})

export const CreateOTRules = Loadable({
  loader: () => import('./Worktimeconfiguration/CreateOTRules'),
  loading: Loading,
})

export const AssetReports = Loadable({
  loader: () => import('./assetReports/AssetReports'),
  loading: Loading,
})
export const UserDetailsReport=Loadable({
  loader: () => import('../containers/assetReports/UserWiseDetailsReport'),
  loading: Loading,
})
export const UnmappedApplication = Loadable({
  loader: () => import('./assetReports/UnMappedApplications'),
  loading: Loading,
})

export const SkippedApplication = Loadable({
  loader: () => import('./assetReports/SkipedApplications'),
  loading: Loading,
})

export const HardwordReports = Loadable({
  loader: () => import('./assetReports/HardwordReports'),
  loading: Loading,
})

export const HardwareDetail = Loadable({
  loader: () => import('./assetReports/HardwordReports'),
  loading: Loading,
})


export const LicenseStatistics = Loadable({
  loader: () => import('./license/LicenseStatistics'),
  loading: Loading,
})
export const ReportList = Loadable({
  loader: () => import('../containers/assetReports/Reports'),
  loading: Loading,
})

export const UserWiseDetailsReport = Loadable({
  loader: () => import('../containers/assetReports/UserReports'),
  loading: Loading,
})

export const UserWiseDetails = Loadable({
  loader: () => import('../containers/assetReports/UserWiseDetailsReport'),
  loading: Loading,
})


export const ITAMDashboard = Loadable({
  loader: () => import('../containers/ItemDashboard/itemDashboard'),
  loading: Loading,
})
export const ViewSoftwareDetails = Loadable({
  loader: () => import('../containers/ItemDashboard/viewSoftwareDetails'),
  loading: Loading,
})
export const ReportsCards = Loadable({
  loader: () => import('../containers/reports/ReportsCards'),
  loading: Loading,
})

export const EmployeeApplicationUsageReport= Loadable({
  loader: () => import('../containers/reports/EmployeeApplicationUsageReport'),
  loading: Loading,
})